module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/8de88e99a17d81538bdeb9fcac14b346.png";